import React from "react";
import './UiSpecification.css';
import Breadcrumb from '../../Layout/Breadcrumb/Breadcrumb';
import Header from '../../Layout/Header/Header';
import Footer from '../../Layout/Footer/Footer';
import Nav from '../../Layout/Nav/Nav';
// import LoginImage from '../../../Images/login.jpg';
import UiButton from './Button/Button';
import UiActionButton from './ActionButton/ActionButton';

function UiSpecification()
{
    return(
      <div className="page-con" style={{"flexDirection": "column"}}>
            <h1>
              Buttons         
            </h1>

            <UiButton urlto="/dashboard" btnname="add"/>

            <br></br>

            <h1>
              Action Buttons         
            </h1>
            <UiActionButton urlto="/dashboard" btnname="edit"/>
            <UiActionButton urlto="/" btnname="view"/>
      </div>
    );
}
export default UiSpecification;